import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ContactForm from "../landing/ContactForm";

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col bg-[#fafafa]">
            <Navbar />
            <main className="flex-1">{children}</main>
            <ContactForm />
            <Footer />
        </div>
    );
};

export default Layout;


